import {useFormikContext} from "formik";

import TextField from "@mui/material/TextField";
import {useTranslation} from "react-i18next";
import {
    CreateFileMeaningFormValues
} from "@/features/InControlPanel/ReferenceBooks/LaboratoryClarifications/FileMeanings/CreateOrEditFileMeaningDialog";

function TitleField() {
    const {t} = useTranslation();

    const form = useFormikContext<CreateFileMeaningFormValues>();

    const helperText = (form.touched.title && form.errors.title) ? t(form.errors.title) : undefined;

    return (
      <TextField
        name="title"
        label={t("Title")}
        variant="outlined"
        onChange={form.handleChange}
        onBlur={form.handleBlur}
        value={form.values.title}
        fullWidth
        error={form.touched.title && Boolean(form.errors.title)}
        helperText={helperText}
        sx={{mb: 2}}
      />
    );
}

export default TitleField;
